import {ImageSkeleton} from '~/components';
function BrandSession() {
    const brands = [
        { id: 28, classes: "border-end" },
        { id: 29, classes: "border-end-md" },
        { id: 30, classes: "border-end border-end-md" },
        { id: 31, classes: "border-end-lg-0" },
        { id: 32, classes: "border-end border-bottom-md-0" },
        { id: 33, classes: "border-end-md border-bottom-md-0" },
        { id: 34, classes: "border-end-md border-bottom-md-0" },
        { id: 35, classes: "border-bottom-md-0" },
    ];
    return (
        <section className="py-5 pt-xl-13 bg-body-emphasis">
            <div className="container-medium">
                <div className="row g-0">
                    {brands.map((brand, index) => (
                        <div key={index} className="col-6 col-md-3">
                            <div
                                className={`p-2 p-lg-5 d-flex flex-center h-100 border-1 border-dashed border-bottom border-translucent ${brand.classes}`}
                            >
                                <ImageSkeleton id={brand.id} heightLoading={100} className={"w-100"} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default BrandSession;